"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.AVAIL_RANGE_DAYS = void 0;
const AVAIL_RANGE_DAYS = exports.AVAIL_RANGE_DAYS = 29;